export default "__VITE_ASSET__Cwy$xqur__"